import React from 'react';

import { SVGComponentProps } from './svg.types';

const BoldSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 12 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherSvgProps}
      >
        <path
          d="M11.3389 4.093C11.337 3.00804 10.9052 1.96804 10.138 1.20086C9.37085 0.433671 8.33085 0.0018508 7.24589 0L1.84589 0C1.5316 0.000529447 1.23034 0.125685 1.0082 0.348017C0.786054 0.570349 0.661153 0.871707 0.660889 1.186V12.814C0.661153 13.1285 0.786192 13.43 1.00855 13.6523C1.23091 13.8747 1.53242 13.9997 1.84689 14H7.24689C8.33185 13.9981 9.37185 13.5663 10.139 12.7991C10.9062 12.032 11.338 10.992 11.3399 9.907C11.3385 9.36408 11.2281 8.82697 11.0151 8.32759C10.8021 7.8282 10.4908 7.37673 10.0999 7C10.4907 6.62325 10.8018 6.17176 11.0147 5.67236C11.2275 5.17296 11.3378 4.63586 11.3389 4.093ZM7.24589 5.814H3.03389V2.373H7.24589C7.69501 2.38383 8.1221 2.56985 8.43592 2.89132C8.74973 3.2128 8.92541 3.64425 8.92541 4.0935C8.92541 4.54275 8.74973 4.9742 8.43592 5.29568C8.1221 5.61715 7.69501 5.80317 7.24589 5.814ZM7.24589 11.627H3.03389V8.186H7.24589C7.69501 8.19683 8.1221 8.38285 8.43592 8.70432C8.74973 9.0258 8.92541 9.45725 8.92541 9.9065C8.92541 10.3558 8.74973 10.7872 8.43592 11.1087C8.1221 11.4302 7.69501 11.6162 7.24589 11.627Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default BoldSVG;
